







import Restricted from './Restricted.vue'

export default {
  components: {
    restricted: Restricted
  }
}
